// Jugador (humano o IA). Contiene su atril y su puntuación.
import { Rack } from './Rack.js';

export class Player {
  constructor({ id, name, isAI = false, aiLevel = null, tiles = [], avatar = '🙂', avatarImage = null }) {
    this.id = id;
    this.name = name;
    this.isAI = isAI;
    this.aiLevel = aiLevel;
    this.avatar = avatar;
    this.avatarImage = avatarImage; // data URL opcional (imagen del jugador)
    this.rack = new Rack(tiles);
    this.score = 0;
    this.finished = false; // se ha quedado sin fichas
  }

  addScore(points) {
    this.score += points;
  }

  serialize() {
    return {
      id: this.id,
      name: this.name,
      isAI: this.isAI,
      aiLevel: this.aiLevel,
      avatar: this.avatar,
      avatarImage: this.avatarImage,
      tiles: this.rack.tiles,
      score: this.score,
      finished: this.finished,
    };
  }

  static deserialize(data) {
    const p = new Player({
      id: data.id,
      name: data.name,
      isAI: data.isAI,
      aiLevel: data.aiLevel,
      avatar: data.avatar,
      avatarImage: data.avatarImage || null,
      tiles: data.tiles || [],
    });
    p.score = data.score || 0;
    p.finished = !!data.finished;
    return p;
  }
}
